module.exports = __webpack_public_path__ + "img/employee.f5e17a54.svg";